import moment from 'moment';

const formatPublishDate = (dateString, translate) => {
    if (!dateString) {
      return null;
    }

    const fullDay = 86400000; // 24 hours
    const date = moment(dateString);
    const today = moment().startOf('day');
    const yesterday = moment(today - fullDay);

    if (date.isSame(today, 'd')) {
      return translate('propertyDetails', 'today');
    } else if (date.isSame(yesterday, 'd')) {
      return translate('propertyDetails', 'yesterday');
    }

    return date.format('DD/MM/YYYY');
};

export default formatPublishDate;
